import React, { useEffect, useState } from 'react';
import { generatePath, Route, Switch, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import routes from '../../../routes';
import { fetchFoodDonorPickupLocations } from '../../../actions/foodDonors';
import useActiveUser from '../../../hooks/useActiveUser';
import { getUserRolesInCurrentlySelectedSite } from '../../../services/auth';
import { Roles } from '../../../models/roles';
import FoodDonorMobileLocationsList from './Components/FoodDonorMobilePickupLocationsList';
import FoodDonorMobilePickupLocationEdit from './Components/FoodDonorMobilePickupLocationEdit';
import OverlayLoader from '../../../components/OverlayLoader';
import FoodDonorMobilePickupLocationAdd from './Components/FoodDonorMobilePickupLocationAdd';

const paths = [
  generatePath(routes.mobileDashboardFoodDonorLocations),
  generatePath(routes.mobileDashboardFoodDonorLocations, { tab: 'Edit' }),
  generatePath(routes.mobileDashboardFoodDonorLocations, { tab: 'Add' }),
];

const FoodDonorMobileLocationsContainer = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const activeUser = useActiveUser();
  const userRoles = getUserRolesInCurrentlySelectedSite(activeUser);
  const [editLocation, seetEditLocation] = useState();
  const foodDonorRolesWithAccess = userRoles.filter(
    (role) =>
      role.role_name === Roles.DonorAdmin ||
      role.role_name === Roles.DonorStaff ||
      role.role_name === Roles.DonorLocationAdmin ||
      role.role_name === Roles.DonorLocationStaff
  );
  const foodDonorId = foodDonorRolesWithAccess[0]?.donor_location_id;
  const foodDonorsPickupLocations = useSelector((state) => state.entities.foodDonors.pickupLocations);
  const foodDonorPickupLocations = foodDonorsPickupLocations.byFoodDonorId[foodDonorId] || [];

  useEffect(() => {
    dispatch(fetchFoodDonorPickupLocations(foodDonorId));
  }, [foodDonorId]);

  const handlePickupLocationEdit = (locationId) => {
    const currentLocation = foodDonorPickupLocations.find((location) => location.id === locationId);

    seetEditLocation(currentLocation);
    history.push(paths[1]);
  };

  const handlePickupLocationAdd = () => {
    history.push(paths[2]);
  };

  return (
    <OverlayLoader isLoading={foodDonorsPickupLocations.inflight}>
      <Switch>
        <Route
          path={[generatePath(routes.mobileDashboardFoodDonorLocations), paths[0]]}
          exact
          render={() => (
            <FoodDonorMobileLocationsList
              pickupLocations={foodDonorPickupLocations}
              onEdit={handlePickupLocationEdit}
              onAdd={handlePickupLocationAdd}
            />
          )}
        />
        <Route
          path={paths[1]}
          exact
          render={() => <FoodDonorMobilePickupLocationEdit location={editLocation} foodDonorId={foodDonorId} />}
        />
        <Route path={paths[2]} exact render={() => <FoodDonorMobilePickupLocationAdd foodDonorId={foodDonorId} />} />
      </Switch>
    </OverlayLoader>
  );
};

export default FoodDonorMobileLocationsContainer;
